export const APP_NAME = 'logged_out_homepage_perseus';
